module.exports = __webpack_public_path__ + "static/media/lishay.c67eaaa2.png";